import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExistsPipe } from './exists.pipe';
import { TransformPipe } from './transform.pipe';
import { EqualsPipe } from './equals.pipe';
import { MapPipe } from './map.pipe';
import { AddPipe } from './add.pipe';
import { MultiplyPipe } from './multiply.pipe';
import { MaxPipe } from './max.pipe';
import { AndPipe } from './and.pipe';
import { SumPipe } from './sum.pipe';
import { NotPipe } from './not.pipe';
import { IncludesPipe } from './includes.pipe';
import { DefaultPipe } from './default.pipe';
import { OrPipe } from './or.pipe';
import { GradientPipe } from './gradient.pipe';
import { PropertyPipe } from './property.pipe';
import { LineTagsPipe } from './line-tags.pipe';
import { LengthPipe } from './length.pipe';
import { GreaterThanPipe } from './greater-than.pipe';
import { FilterPipe } from './filter.pipe';
import { ConcatPipe } from './concat.pipe';
import { StalePipe } from './stale.pipe';
import { FieldWarningPipe } from './field-warning.pipe';

@NgModule({
    declarations: [
        ExistsPipe,
        TransformPipe,
        EqualsPipe,
        MapPipe,
        AddPipe,
        MultiplyPipe,
        MaxPipe,
        AndPipe,
        SumPipe,
        NotPipe,
        IncludesPipe,
        DefaultPipe,
        OrPipe,
        GradientPipe,
        PropertyPipe,
        LineTagsPipe,
        LengthPipe,
        GreaterThanPipe,
        FilterPipe,
        ConcatPipe,
        StalePipe,
        FieldWarningPipe
    ],
    exports: [
        ExistsPipe,
        TransformPipe,
        EqualsPipe,
        MapPipe,
        AddPipe,
        MultiplyPipe,
        MaxPipe,
        AndPipe,
        SumPipe,
        NotPipe,
        IncludesPipe,
        DefaultPipe,
        OrPipe, 
        GradientPipe,
        PropertyPipe,
        LineTagsPipe,
        LengthPipe,
        GreaterThanPipe,
        FilterPipe,
        ConcatPipe,
        StalePipe,
        FieldWarningPipe,
    ],
    imports: [
        CommonModule
    ]
})
export class PipesModule { }
